import { NgModule } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import { MainNavigationComponent } from './components/high-level-nav/main-navigation.component';
import { RouterModule, RouterLink, RouterLinkActive } from '@angular/router';
import { BreadcrumbsNavigationComponent } from './components/breadcrumbs-navigation/breadcrumbs-navigation.component';
import { TopNavigationComponent } from './components/top-navigation/top-navigation.component';


@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		// Explicitly import standalone pipes/directives for Angular v17+
		AsyncPipe,
		RouterLink,
		RouterLinkActive,
		TopNavigationComponent
	],
	declarations: [
		MainNavigationComponent,
		BreadcrumbsNavigationComponent
	],
	exports: [
		MainNavigationComponent,
		BreadcrumbsNavigationComponent,
		TopNavigationComponent
	]
})
export class NavigationModule {
}
